export const environment_dev = {
  PRODUCTION: false,
  APP_ENDPOINT: 'https://app.devenv.printix.net',
  CHECK_SERVER_HEALTH: 'https://api.devenv.printix.net/manage/health',
  INTERNAL_TEST_WAIT_TIME: 'https://api.devenv.printix.net/internal/testing/wait/',
  INTERNAL_TEST_RETURN_SET_STATUS_CODE: 'https://api.devenv.printix.net/internal/testing/status/',
  ENDPOINT_API: 'https://api.devenv.printix.net',
  ENDPOINT_TENANT_DOMAIN: 'https://auth.devenv.printix.net/oauth/authorize/tenant/',
  ENDPOINT_TENANT_LESS: 'https://auth.devenv.printix.net/oauth/authorize',
  ENDPOINT_SIGN_IN_MS: 'https://auth.devenv.printix.net/identity-providers/azure/signin?redirect_uri=',
  ENDPOINT_SIGN_IN_GOOGLE: 'https://auth.devenv.printix.net/identity-providers/google/signin?redirect_uri=',
  ENDPOINT_AUTH_TOKENS: 'https://auth.devenv.printix.net/oauth/token',
  ENDPOINT_GET_TENANT_USER: 'https://api.devenv.printix.net/v1/users/me',
  ENDPOINT_FIND_TENANT: 'https://api.devenv.printix.net/v1.2/find/',
  ENDPOINT_SIGN_OUT_BROWSER: 'https://auth.devenv.printix.net/logout',
  ENDPOINT_SIGN_OUT_NATIVE: 'https://auth.devenv.printix.net/oauth/logout',
  ENDPOINT_REVOKE_TOKEN: 'https://auth.devenv.printix.net/oauth2/revoke',
  ENVIRONMENT_STATE: 'devenv'
};